export const GET_CONTACTS = 'entities/GET_CONTACTS'
export const ADD_CONTACT = 'entities/ADD_CONTACT'
export const EDIT_CONTACTS = 'entities/EDIT_CONTACTS'
export const DELETE_CONTACTS = 'entities/DELETE_CONTACTS'
export const ACTIVE_CONTACT = 'entities/ACTIVE_CONTACT'
export const INACTIVE_CONTACT = 'entities/INACTIVE_CONTACT'
export const GET_CONTACT = 'entities/GET_CONTACT'
export const START_LOADING_CONTACTS = 'entities/START_LOADING_CONTACTS'
export const STOP_LOADING_CONTACTS = 'entities/STOP_LOADING_CONTACTS'  
